export default __webpack_public_path__ + "static/media/Group 840 (1).99000c09.svg";